import { SVGProps } from 'react';

const SvgPrescription = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M0 32C0 14.3 14.3 0 32 0h144c61.9 0 112 50.1 112 112 0 52.8-36.6 97.1-85.8 108.9l85.8 85.8-45.3 45.3-128-128H64v64c0 17.7-14.3 32-32 32S0 305.7 0 288V32zm288 365.3 45.3-45.3 105.3 105.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 397.3zM64 160h112c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96z"
      className="prescription_svg__fa-primary"
    />
    <path
      d="M438.6 201.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l256-256c12.5-12.5 32.8-12.5 45.3 0z"
      style={{
        opacity: 0.4,
      }}
    />
  </svg>
);
export default SvgPrescription;
